<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss/society`">社会服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss/society/training/list`">企业培训</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content">
        <div class="head">
          <div class="left">
            <h3 class="title">{{ model.Name }}</h3>
            <div class="attrs">
              <p class="desc">
                <span>报名时间：{{
                    formartDate(model.RegistStartTime, "minutes")
                  }}
                  至 {{ formartDate(model.RegistEndTime, "minutes") }}</span>
              </p>
              <p class="desc">
                <span>培训时间：{{
                    formartDate(model.trainingPeriod, "minutes")
                  }}
                  至 {{ formartDate(model.EndTime, "minutes") }}</span>
                <span>培训地址：{{ model.Address }}</span>
              </p>
            </div>
          </div>
          <div class="right">
            <div class="btn">
              <a @click="dialogVisible = true" v-if="applyEnable">在线申请</a>
              <a v-else pointer-events="none" disabled="disabled" style="border:'black';color:'black';">
                {{ applyBtnTitle }}
              </a>
            </div>
            <el-dialog title="申请" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
              <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="姓名" prop="Name">
                  <el-input v-model="form.Name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="Phone">
                  <el-input v-model="form.Phone"></el-input>
                </el-form-item>
                <el-form-item label="申请内容">
                  <el-input type="textarea" v-model="form.Remark"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
        <div class="detail-content">
          <div class="left">
            <div class="video" :style="
                'background:url(' +
                  (model.Illustration || '/static/img/no-img.png') +
                  ') no-repeat;    background-size: cover;background-position: center;'
              " @click="handleVideo"></div>

            <!-- <div class="name">{{ model.Name }}</div>
            <div class="attrs">
              <span>{{ formartDate(model.playTimes, "day") }}播放</span>
              <span>发布时间：{{ formartDate(model.publishTime, "day") }}</span>
            </div> -->
            <column-header2 :data="{ name: '企业培训详情' }"></column-header2>
            <div class="content" v-html="model.content"></div>
            <div class="attach" v-if="model.File && model.File.length > 0">
              <div class="attach-title">附件信息</div>
              <p v-for="(item, i) in model.File" :key="i">
                <i class="el-icon-link"></i>
                <a class="file" :href="`${item.ViewFilePath}`" :download="item.FileName">{{ item.FileName }}</a>
              </p>
            </div>
          </div>
          <div class="right">
            <column-header2 :data="{ name: '企业培训推荐' }"></column-header2>
            <preach-card v-for="item in trainingList" :data="item" :key="item.id"></preach-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, getData } from "api/app";
import { signUpTrain, trainAddViewCount } from "api/research";
import { updateEntity } from "api/content-data";
import PreachCard from "../components/PreachCard";
import ColumnHeader from "_c/ColumnHeader2";
import toolMixin from "@/mixins/content-tools.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      applyEnable: false,
      applyBtnTitle: "",
      dialogVisible: false,
      trainingList: [],
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "",
        prev: null,
        next: null
      },
      form: {
        TrainId: "",
        Content: "",
        Name: "",
        Phone: ""
      },
      rules: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
      },
      id: null,
      preachList: []
    };
  },
  mixins: [toolMixin],
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [PreachCard.name]: PreachCard
  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    handleVideo() {
      if (this.model.LiveTypeId && this.model.LiveTypeId != 0) {
        window.open(this.model.LiveUrl);
      } else {
        this.$alert("请在线下参加培训", { type: "warning" });
        console.log("这是一场线下的培训");
      }
    },
    loadData() {
      getDetail({
        name: "Train",
        id: this.id,
        college: this.collegeData.college.Id
      }).then(res => {
        const item = res;
        const arr = {
          Name: item.Name,
          RegistStartTime: item.RegistStartTime,
          RegistEndTime: item.RegistEndTime,
          trainingPeriod: item.StartTime,
          EndTime: item.EndTime,
          Address: item.Address,
          content: item.Content,
          File: item.File,
          LiveId: item.LiveId,
          LiveUrl: item.LiveUrl,
          Illustration: item.Illustration,
          LiveType: item.LiveType,
          LiveTypeId: item.LiveTypeId
        };

        this.model = arr || {};
        this.applyEnable = true;
        var now = new Date();
        var rStart = new Date(arr.RegistStartTime);
        var rEnd = new Date(arr.RegistEndTime);
        if (rStart > now) {
          this.applyEnable = false;
          this.applyBtnTitle = "未到报名时间";
        }
        if (rEnd < now) {
          this.applyEnable = false;
          this.applyBtnTitle = "报名已结束";
        }
        // this.model = obj || {};
      });
      var params = [
        {
          Key: "College",
          Value: this.collegeData.college.Id,
          CompareType: "EqualTo"
        }
      ];
      getData({ name: "Train", top: 3, params: params }).then(res => {
        this.trainingList = (res || []).filter(item => item.Id != this.id);
      });
      // getData({ name: "Preach", top: 3 }).then(res => {
      //   const arr = [];
      //   res.forEach(item => {
      //     if (item.Id != this.id) {
      //       arr.push({
      //         id: item.Id,
      //         pic: item.Picture,
      //         name: item.Headline,
      //         view: item.ViewCount,
      //         time: item.StartTime,
      //         link: item.LiveUrl
      //       });
      //     }
      //   });
      //   this.preachList = arr || [];
      // });
    },

    // updateViewCount() {
    //   var dic = {};
    //   dic.TableId = "Preach";
    //   dic.Id = this.$route.params.id;
    //   dic.ViewCount = (this.model.view ?? 0) + 1;
    //   updateEntity(dic)
    //     .then(res => {
    //       if (res.IsSuccess) {
    //         console.log("更新浏览量成功");
    //       }
    //     })
    //     .catch(err => {
    //       console.log("更新浏览量异常" + err);
    //     });
    // },
    init() {
      this.id = this.$route.params.id;
      this.loadData();
      debugger;
      trainAddViewCount({ id: this.$route.params.id })
        .then(res => {
          debugger;
          if (res.IsSuccess) {
            console.log("增加浏览量");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitForm(formName) {
      debugger;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.TrainId = this.id;
          signUpTrain(this.form)
            .then(res => {
              if (res.IsSuccess) {
                this.$message.success("报名成功");
                this.dialogVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.warning("报名失败:" + res.Message);
              }
            })
            .catch(err => {
              this.$message.warning("报名失败:" + err);
            });
        } else {
          this.$message.warning("存在未输入字段");
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  margin: 0 -72px 0 -72px;
  border-bottom: 1px solid #eee;
  padding: 0 72px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 8px 0 15px 0;
    line-height: 1.4em;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 28px;
    padding-bottom: 24px;
    span {
      padding-right: 50px;
    }
    .left {
      span {
        position: relative;
        padding-left: 10px;
        margin-left: 10px;
        color: #666;
        &::before {
          width: 1px;
          height: 12px;
          background-color: #ccc;
          position: absolute;
          left: 0;
          top: 1px;
          content: ' ';
        }
      }
      strong {
        color: #ff6010;
        font-weight: 500;
        font-size: 20px;
      }
      h3 {
        font-size: 24px;
        font-weight: 500;
        padding-bottom: 12px;
      }
    }
  }
  .link {
    float: right;
    margin-top: 40px;
  }
  .right {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .date {
      color: #ccc;
      text-align: center;
      padding-top: 10px;
    }
  }
  .btn {
    a {
      width: 88px;
      height: 32px;
      border-radius: 20px;
      border: 1px solid $primary-color;
      color: $primary-color;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-left: 8px;
      &.send {
        color: #fff;
        background-color: $primary-color;
      }
    }
  }
}
.attach {
  &-title {
    font-size: 16px;
    margin: 30px 0 10px 0;
  }
  p {
    height: 22px;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
    padding-bottom: 5px;
    i {
      margin-right: 5px;
    }
    a.file {
      margin-right: 30px;
      text-decoration: underline !important;
    }
    a.btn {
      color: $primary-color;
    }
  }
}
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .g-content {
    padding: 24px 72px 40px 72px;
  }
  .detail-content {
    padding-top: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      padding-right: 16px;
      // width: 776px;
      .video {
        // background-color: rgba($color: #000000, $alpha: 0.5);
        width: 100%;
        height: 436px;
        overflow: hidden;
        background-size: cover;
        &:hover {
          cursor: pointer;
        }
      }
      .name {
        font-size: 26px;
        line-height: 40px;
        padding: 24px 0 16px 0;
      }
      .attrs {
        font-size: 15px;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        border-bottom: 1px solid #eee;
        padding-bottom: 24px;
        vertical-align: middle;
        span {
          position: relative;
          padding-left: 10px;
          margin-left: 10px;
          &::before {
            width: 1px;
            height: 12px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            top: 2px;
            content: ' ';
          }
        }
        span:first-child {
          padding-left: 0;
          margin-left: 0;
          &::before {
            display: none;
          }
        }
      }
      .content {
        line-height: 32px;
        color: #666;
        font-size: 15px;
      }
      ::v-deep .comp-column-header {
        padding-top: 24px;
      }
    }
    .right {
      width: 376px;
      ::v-deep .comp-preach {
        margin-left: 0 !important;
      }
      ::v-deep .comp-column-header:first-child {
        padding-top: 0;
      }
    }
  }
}
</style>
